<div class="dash-shell add-docs">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/dashboard">Home</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      @if (record(); as pa) {
        <a class="page-head__crumb" [routerLink]="['/entity', pa.entity_short_id, 'dashboard']">{{
          pa.entity_name
        }}</a>
        <span class="page-head__sep" aria-hidden="true">/</span>
        <a
          class="page-head__crumb"
          [routerLink]="['/entity', pa.entity_short_id, 'applications', 'submission', pa.short_id]"
          >Submission</a
        >
        <span class="page-head__sep" aria-hidden="true">/</span>
      }
      <span class="page-head__crumb page-head__crumb--current" aria-current="page"
        >Add documents</span
      >
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">Add documents to your enquiry</h1>
        <p class="page-head__subtitle">
          CapX is reviewing what you shared. Anything you add here is included in that review —
          there's nothing to resubmit.
        </p>
      </div>
      @if (record(); as pa) {
        <div class="page-head__actions">
          <app-status-chip [status]="pa.review_status" data-testid="add-docs-status-chip" />
        </div>
      }
    </div>
  </header>

  @if (loading()) {
    <div class="add-docs__loading" role="status" aria-live="polite" data-testid="add-docs-loading">
      <mat-spinner diameter="28" />
      <span>Loading…</span>
    </div>
  } @else if (loadError()) {
    <div class="sg-empty sg-empty--error sg-empty--bordered" data-testid="add-docs-error">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load this enquiry</p>
      <button mat-stroked-button type="button" (click)="load()">Try again</button>
    </div>
  } @else if (!accepting()) {
    <!-- Closed to new documents (PROCEEDED, or an editable state that belongs in the wizard). -->
    <div class="sg-empty sg-empty--bordered" data-testid="add-docs-closed">
      <app-icon name="info" [size]="40" />
      <p class="sg-empty__title">This enquiry isn't taking new documents here</p>
      <p class="sg-empty__desc">
        If it's still open, continue it from your dashboard; if CapX has opened your application,
        add documents on the application itself.
      </p>
      <a mat-stroked-button [routerLink]="['/entity', entityId, 'dashboard']">Back to dashboard</a>
    </div>
  } @else {
    <mat-card appearance="outlined" class="add-docs__card">
      <mat-card-content>
        @if (serverError()) {
          <div class="sg-banner sg-banner--error" role="alert" data-testid="add-docs-server-error">
            <app-icon name="x-circle" [size]="18" />
            <span>{{ serverError() }}</span>
          </div>
        }

        @if (addedCount() > 0) {
          <p class="add-docs__added" role="status" data-testid="add-docs-added-count">
            <app-icon name="check-circle" [size]="16" />
            <span>
              {{ addedCount() }} {{ addedCount() === 1 ? 'document' : 'documents' }} added since you
              submitted — CapX sees them with your enquiry.
            </span>
          </p>
        }

        @if (showAiConsentBox()) {
          <div class="add-docs__consent" data-testid="add-docs-ai-consent">
            <app-ai-consent-checkbox
              testId="add-docs-ai-consent-checkbox"
              [checked]="aiConsent()"
              (changed)="onAiConsentChange($event)"
            />
            @if (consentBlocked()) {
              <p class="add-docs__consent-error" role="alert">
                <app-icon name="shield" [size]="16" />
                <span
                  >Tick the box above before uploading — we can't check your documents without your
                  consent.</span
                >
              </p>
            }
          </div>
        }

        @for (block of DOC_BLOCKS; track block.type.value) {
          <div class="checklist__row">
            <div class="checklist__row-head">
              <span class="checklist__row-title">{{ block.type.label }}</span>
            </div>
            <p class="checklist__why">{{ block.why }}</p>
            <app-doc-drop
              [docType]="block.type"
              [uploads]="uploadsByType().get(block.type.value) ?? []"
              (filesPicked)="onFilesPicked(block.type.value, $event)"
              (remove)="removeUpload($event)"
            />
          </div>
        }

        <div class="add-docs__nav">
          @if (anyInFlight()) {
            <span class="add-docs__hint">Waiting for your documents to finish uploading…</span>
          } @else {
            <span></span>
          }
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="done()"
            [disabled]="anyInFlight()"
            data-testid="add-docs-done"
          >
            Done
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>
